var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{staticClass:"pa-0 ma-0",attrs:{"hide-details":"auto","filled":"","dense":"","label":_vm.label,"placeholder":_vm.placeholder,"rules":[_vm.presenceRule]},on:{"change":_vm.handleInput},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }